import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Component, inject, OnInit } from '@angular/core';
import { UsersService } from '@app/services/users.service';
import { MainService } from '@app/services/main.service';
import { ActivatedRoute, Router } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-dialog',

    templateUrl: './verify-email-dialog.component.html',
    styleUrls: ['./verify-email-dialog.component.scss'],
    imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, FormsModule],
})
export class VerifyEmailDialogComponent implements OnInit {
    dialogRef = inject<MatDialogRef<VerifyEmailDialogComponent>>(MatDialogRef);

    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);
    public readonly mainService = inject(MainService);
    public readonly usersService = inject(UsersService);

    public email: string;
    public code: string;

    constructor() {
        const data = inject(MAT_DIALOG_DATA);

        this.email = data.email;
        this.code = data.code;
    }

    ngOnInit(): void {
        this.usersService.patchUserContact(this.usersService.user?._id, {
            contactId: this.usersService.user?.contactId,
            contact: { 'contacts.emailVerification': true },
        });
        setTimeout(() => {
            this.verify();
        }, 1);
    }

    public verify() {
        if (this.email && this.code) {
            if (
                this.usersService.user?.contact?.email === this.email &&
                this.usersService.user?.contact?.emailVerificationCode.toString() === this.code.toString()
            ) {
                this.mainService.verifiedHere = true;
                this.usersService.user.contact.emailVerified = true;
                this.usersService.patchUserContact(this.usersService.user?._id, {
                    contactId: this.usersService.user?.contactId,
                    contact: { 'contacts.emailVerified': true, 'contacts.emailVerificationCode': null },
                });
            }
        }
    }

    public close() {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {},
            queryParamsHandling: '',
        });
    }
}
